import { combineReducers } from "redux";

import arrivideoReducer from "../modules/arriVideo/slice.js";
import establishmentReducer from "../modules/emailAddressEstablishment/slice.js";
import malfunctionReducer from "../modules/malfunctions/slice.js";
import settingsReducer from "../modules/settings/slice.js";
import softwareNotificationReducer from "../modules/softwareNotifications/slice.js";
import softwarePackageReducer from "../modules/softwarePackages/slice.js";
import tabletRegistrationReducer from "../modules/tabletRegistration/slice.js";
import trainStopSignalImageReducer from "../modules/trainStopSignalImages/slice.js";
import urlEntryReducer from "../modules/urlEntry/slice.js";
import userNotificationReducer from "../modules/userNotifications/slice.js";

import sessionReducer from "./sessionSlice.js";

const reducer = combineReducers({
  session: sessionReducer,
  softwarePackage: softwarePackageReducer,
  softwareNotification: softwareNotificationReducer,
  userNotification: userNotificationReducer,
  establishment: establishmentReducer,
  urlEntry: urlEntryReducer,
  malfunction: malfunctionReducer,
  arrivideo: arrivideoReducer,
  settings: settingsReducer,
  tabletRegistration: tabletRegistrationReducer,
  trainStopSignalImages: trainStopSignalImageReducer,
});

export default reducer;
